module.exports = __webpack_public_path__ + "static/media/family.d8a952bb.JPG";